export default __webpack_public_path__ + "static/media/62t.0db6abf7.jpg";